import OngoingOrder from './OngoingOrder';
import OrderBasketSummary from './OrderBasketSummary';
import OrderPaymentBreakdown from './OrderPaymentBreakdown';
import OrderRating from './OrderRating';
import OrderTimeline from './OrderTimeline';
import ScheduledOrderInfo from './ScheduledOrderInfo';

export default {
  OngoingOrder,
  OrderBasketSummary,
  OrderPaymentBreakdown,
  OrderRating,
  OrderTimeline,
  ScheduledOrderInfo,
};
